/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Capture_Hint_FrameInputs */

const en_us2_body_assessment_capture_hint_frame = /** @type {(inputs: Body_Assessment_Capture_Hint_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your whole body in frame, head to feet, about 2 m from the phone.`)
};

const pt_br2_body_assessment_capture_hint_frame = /** @type {(inputs: Body_Assessment_Capture_Hint_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corpo inteiro no quadro, da cabeça aos pés, a uns 2 m do celular.`)
};

const es_419_body_assessment_capture_hint_frame = /** @type {(inputs: Body_Assessment_Capture_Hint_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo tu cuerpo en el encuadre, de la cabeza a los pies, a unos 2 m del teléfono.`)
};

const pt_pt2_body_assessment_capture_hint_frame = /** @type {(inputs: Body_Assessment_Capture_Hint_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corpo inteiro no enquadramento, da cabeça aos pés, a uns 2 m do telemóvel.`)
};

const fr_fr2_body_assessment_capture_hint_frame = /** @type {(inputs: Body_Assessment_Capture_Hint_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout ton corps dans le cadre, de la tête aux pieds, à environ 2 m du téléphone.`)
};

const de_de2_body_assessment_capture_hint_frame = /** @type {(inputs: Body_Assessment_Capture_Hint_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganzer Körper im Bild, von Kopf bis Fuß, etwa 2 m vom Handy entfernt.`)
};

const it_it2_body_assessment_capture_hint_frame = /** @type {(inputs: Body_Assessment_Capture_Hint_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutto il corpo nell'inquadratura, dalla testa ai piedi, a circa 2 m dal telefono.`)
};

/**
* | output |
* | --- |
* | "Your whole body in frame, head to feet, about 2 m from the phone." |
*
* @param {Body_Assessment_Capture_Hint_FrameInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_capture_hint_frame = /** @type {((inputs?: Body_Assessment_Capture_Hint_FrameInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Capture_Hint_FrameInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_capture_hint_frame(inputs)
	if (locale === "es-419") return es_419_body_assessment_capture_hint_frame(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_capture_hint_frame(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_capture_hint_frame(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_capture_hint_frame(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_capture_hint_frame(inputs)
	return en_us2_body_assessment_capture_hint_frame(inputs)
});
export { body_assessment_capture_hint_frame as "body-assessment.capture_hint_frame" }